import List from 'src/storage/list';

class ClinicProfileGalleryModel extends List {
  id = 'ClinicProfileGalleryModel';
  listLimit = 20;
  defaultState = () => ({
    current: 'recent',
    gallery: {},
    total: 0,
    pageIndex: 0,
    tags: []
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;

  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'clinic/gallery/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'clinic/gallery/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  initLoad = (clinic, isSmallScreen) => {
    const gallery = {
      main: clinic?.gallery?.main,
      tags: Object.keys(clinic?.gallery?.tags || {})
    };

    this.setStateSilent({ clinic, gallery, isSmallScreen });
    this.refresh();
  };

  listParams(loadMore) {
    if (!this.state.clinic?.id) return null;

    let req = {
      userId: this.state.clinic?.id,
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      tags: this.state.tags || []
    };

    if (loadMore && this.state.isSmallScreen) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
}

const model = new ClinicProfileGalleryModel();
export default model;
